<div fxLayout="column" fxLayoutAlign="space-between">
  <div fxFlex>
    <h3>Remove listing from property</h3>
    <p>
      <strong>{{ dialogData.listingName }}</strong>
      will be removed from this property and all settings related will no longer be available.
    </p>
  </div>

  <div fxLayoutAlign="end center" fxLayoutGap="8px" style="margin-top: 40px">
    <button type="submit" mat-flat-button class="button__secondary" (click)="cancelClicked()">Cancel</button>
    <button type="submit" mat-flat-button (click)="okClicked()">Remove</button>
  </div>
</div>
